import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import RejectionLogLayer from "../../components/Utilities/RejectionLogLayer";

const RejectionLogPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Rejection Log" />
      <RejectionLogLayer />
    </MasterLayout>
  );
};

export default RejectionLogPage;
